<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">One more Thing!</div>
        </md-card-header>
        <div class="md-title">
          Please provide your email address &
          <br />
          a 4 digit PIN you will remember so
          <br />
          we can provide you with your SVID,
          <br />
          and you can login again here if needed.
        </div>
        <md-card-content>
          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input
              type="email"
              name="email"
              id="email"
              autocomplete="email"
              v-model="form.email"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.email.required"
              >The email is required</span
            >
            <span class="md-error" v-else-if="!$v.form.email.email"
              >Invalid email</span
            >
          </md-field>
          <md-field>
            <label for="password">4 DIGITS PIN</label>
            <md-input
              type="password"
              name="password"
              id="password"
              autocomplete="password"
              v-model="form.password"
            />
          </md-field>
        </md-card-content>
        <md-card-actions>
          <md-button type="submit" class="md-primary">Next</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "ValidEmail",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    phoneNumber: null,
    selectedDate: null,
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  mounted() {
    this.form.firstName = this.$route.params.firstName;
    this.form.lastName = this.$route.params.lastName;
    this.selectedDate = this.$route.params.date;
    this.phoneNumber = this.$route.params.phoneNumber;
    console.log(this.phoneNumber);
  },
  methods: {
    goConfirm() {
      this.validateUser();

      this.$router.push({
        name: "ConfirmEmail",
        params: {
          email: this.form.email,
          password: this.form.password,
        },
      });
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.firstName = null;
      this.form.lastName = null;
    },
    saveUser() {
        this.$router.push({
          name: "ConfirmEmail",
          params: {
            email: this.form.email,
            password: this.form.password,
          },
        });
    },
    validateUser() {
      this.$v.$touch();
      console.log("asdfvaild");

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card-actions {
  flex-direction: column;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
}
.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}
.md-layout-item.md-size-50 {
  min-width: 100%;
  max-width: 50%;
} */
</style>